import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

function today() {
  const now = new Date()
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
}

export const useDayPeriodStore = create(
  persist(
    set => ({
      date: today(),
      setDate: date => set({ date }),
    }),
    {
      name: 'day-period',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
